export class MailConfiguracion {
  constructor(
    public readonly Id: number,
    public readonly Codigo: string | null,
    public readonly ProveedorEnvio: number | null,
    public readonly ProveedorEnvioNombre: string | null,
    public readonly MailSaliente: string | null,
    public readonly MailSalienteDisplayName: string | null,
    public readonly MailResponderA: string | null,
    public readonly ServidorMail: string | null,
    public readonly PuertoServidorMail: number | null,
    public  HabilitarSsl: boolean,
    public readonly Usuario: string | null,
    public readonly Clave: string | null,
    public CertificadoExternoUrl: string | null,
    public ClaveCertificadoExterno: string | null,
    public  Activo: boolean
  ) {}
}

export class SearchMailConfiguracionRequest {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,
    public readonly Codigo: string | null,
    public readonly MailSaliente: string | null,
    public readonly MailSalienteDisplayName: string | null,
    public readonly VerSoloActivos: boolean | null
  ) {}
}
export class SaveMailConfiguracionDto {
  constructor(
    public Codigo: string | null,
    public readonly ProveedorEnvio: number | null,
    public readonly MailSaliente: string | null,
    public readonly MailSalienteDisplayName: string | null,
    public readonly MailResponderA: string | null,
    public readonly ServidorMail: string | null,
    public readonly PuertoServidorMail: number | null,
    public readonly HabilitarSsl: boolean | null,
    public readonly Usuario: string | null,
    public readonly Clave: string | null,
    public readonly CertificadoExternoUrl: string | null,
    public readonly ClaveCertificadoExterno: string | null,
    public Activo: boolean
  ) {}
}

export class SearchMailConfiguracionResponse {
  constructor(
    public readonly count: number,
    public readonly result: MailConfiguracion[]
  ) {}
}

export class MailProveedorEnvio {
  constructor(
    public readonly Id: number,
    public readonly Nombre: string
  ) {}
}

export class SendTestEmailDto {
  constructor(
    public readonly MailConfiguracion: SaveMailConfiguracionDto,
    public readonly MailDestinatario: string
  ) {}
}

export class UploadMailCertificadoDto{
  constructor(
    public NombreCertificado: string | null,
    public CertificadoExternoUrl: string | null,
  ){}
}
